import { createSlice } from "@reduxjs/toolkit";
import { Booking } from "../../booking-page/store/slice";

type InitialState = {
  data: Booking | null;
  isLoading: boolean;
  isAssigning: boolean;
};

const initialState: InitialState = {
  data: null,
  isLoading: false,
  isAssigning: false,
};

const bookingShowSlice = createSlice({
  name: "bookingShowSlice",
  initialState,
  reducers: {
    fetchData: (state, action) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    cancel: (state, action) => {
      state.isLoading = true;
    },
    assign: (state, action) => {
      state.isAssigning = true;
    },
    setIsAssigning: (state, action) => {
      state.isAssigning = action.payload;
    },
    setOwner: (state, action) => {
      if (state.data) {
        state.data.owner = action.payload;
      }
    },
    reset: () => initialState,
  },
});

export default bookingShowSlice;
